import { Box, TextField, Typography } from '@mui/material';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';

import { ParameterUnsetAttribute } from '~pages/SipConfiguration/domain';

import BaseNode from '../BaseNode';
import { ContactFlowNodeProps } from '..';

export default function UnsetAttributeNode(props: ContactFlowNodeProps) {
  const form = useForm<ParameterUnsetAttribute>({
    defaultValues: props.data.parameter.unsetAttribute,
  });

  return (
    <BaseNode
      {...props}
      title='Unset Attribute'
      parameterForm={form}
      renderParameterForm={(unsetAttribute) => <Typography>Attribute Name: {unsetAttribute?.name || '--'}</Typography>}
      transformParameter={(unsetAttribute) => ({ unsetAttribute })}
      renderEditParameter={({ control }) => (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}>
          <Controller
            control={control}
            name='name'
            defaultValue=''
            rules={{
              required: 'Attribute Name required.',
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                fullWidth
                label='Attribute Name'
                error={Boolean(error)}
                helperText={error?.message}
              />
            )}
          />
        </Box>
      )}
    />
  );
}
